<section class="admin-page ct-page">
  <div class="ct-toolbar">
    <div>
      <p class="subtitle">{{ 'products.subtitle' | t }}</p>
    </div>
    <button class="ct-btn ct-btn-primary" type="button" (click)="openCreate()">
      {{ 'products.new' | t }}
    </button>
  </div>

  <div class="filters">
    <select
      class="ct-select"
      [ngModel]="filterBrandId()"
      (ngModelChange)="filterBrandId.set($event); onFilterChange()"
      name="filterBrand"
    >
      <option value="">{{ 'portal.catalog.allBrands' | t }}</option>
      @for (brand of brandOptions(); track brand.id) {
        <option [value]="brand.id">{{ brand.name }}</option>
      }
    </select>
    <select
      class="ct-select"
      [ngModel]="filterCategoryId()"
      (ngModelChange)="filterCategoryId.set($event); onFilterChange()"
      name="filterCategory"
    >
      <option value="">{{ 'portal.catalog.allCategories' | t }}</option>
      @for (cat of categoryOptions(); track cat.id) {
        <option [value]="cat.id">{{ cat.label }}</option>
      }
    </select>
  </div>

  <div class="ct-card ct-table-wrap">
    <table class="ct-table">
      <thead>
        <tr>
          <th>{{ 'common.name' | t }}</th>
          <th>SKU</th>
          <th>{{ 'portal.catalog.brand' | t }}</th>
          <th>{{ 'products.category' | t }}</th>
          <th class="col-price">{{ 'products.price' | t }}</th>
          <th class="col-status">{{ 'common.status' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr><td colspan="7">{{ 'common.loading' | t }}</td></tr>
        } @else if (items().length === 0) {
          <tr><td colspan="7">{{ 'products.empty' | t }}</td></tr>
        } @else {
          @for (item of items(); track item.id) {
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.sku }}</td>
              <td>{{ item.brandName ?? brandName()(item.brandId) }}</td>
              <td>{{ item.categoryName ?? '—' }}</td>
              <td class="col-price">{{ money(item.price) }}</td>
              <td class="col-status">
                <span class="ct-badge" [class.ct-badge-success]="item.isActive" [class.ct-badge-muted]="!item.isActive">
                  {{ (item.isActive ? 'common.active' : 'common.inactive') | t }}
                </span>
              </td>
              <td class="actions">
                <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="openEdit(item)">
                  {{ 'common.edit' | t }}
                </button>
                <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="remove(item)">
                  {{ 'common.delete' | t }}
                </button>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>
</section>

@if (dialogOpen()) {
  <div class="ct-dialog-backdrop" (click)="closeDialog()">
    <div class="ct-dialog wide" (click)="$event.stopPropagation()" role="dialog" aria-modal="true">
      <header class="ct-dialog-head"><h2>{{ (editingId() ? 'products.edit' : 'products.new') | t }}</h2>        <button type="button" class="ct-dialog-close" (click)="closeDialog()" [attr.aria-label]="'common.close' | t">
          <span class="material-symbols-outlined" aria-hidden="true">close</span>
        </button></header>
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="ct-dialog-body">
        <div class="ct-form-grid">
          <div class="ct-field">
            <label for="name">{{ 'common.name' | t }}</label>
            <input id="name" class="ct-input" formControlName="name" (input)="onNameChange($any($event.target).value)" />
          </div>
          <div class="ct-field">
            <label for="slug">{{ 'common.slug' | t }}</label>
            <input id="slug" class="ct-input" formControlName="slug" />
          </div>
          <div class="ct-field">
            <label for="model">{{ 'portal.model' | t }}</label>
            <input id="model" class="ct-input" formControlName="model" />
          </div>
          <div class="ct-field">
            <label for="brandId">{{ 'portal.catalog.brand' | t }}</label>
            <select id="brandId" class="ct-select" formControlName="brandId">
              @for (brand of brands(); track brand.id) {
                <option [value]="brand.id">{{ brand.name }}</option>
              }
            </select>
          </div>
          <div class="ct-field">
            <label for="categoryId">{{ 'products.category' | t }}</label>
            <select
              id="categoryId"
              class="ct-select"
              formControlName="categoryId"
              (change)="onCategoryChange()"
            >
              @for (cat of leafCategories(); track cat.id) {
                <option [value]="cat.id">{{ cat.name }}</option>
              }
            </select>
          </div>
          <div class="ct-field full">
            <label for="description">{{ 'products.description' | t }}</label>
            <textarea id="description" class="ct-input" rows="8" formControlName="description"></textarea>
            <p class="hint">{{ 'products.descriptionHint' | t }}</p>
          </div>
          <div class="ct-field">
            <label>
              <input type="checkbox" formControlName="isActive" /> {{ 'common.active' | t }}
            </label>
          </div>
        </div>

        <div class="attrs">
          <h3>{{ 'products.variants' | t }}</h3>
          <p class="hint">{{ 'products.variantsHint' | t }}</p>

          <div class="ct-field" style="max-width: 16rem; margin-bottom: 0.85rem">
            <label for="optionName">{{ 'products.optionName' | t }}</label>
            <input
              id="optionName"
              class="ct-input"
              [ngModel]="optionName()"
              (ngModelChange)="setOptionName($event)"
              [ngModelOptions]="{ standalone: true }"
              [placeholder]="'products.optionNamePlaceholder' | t"
            />
          </div>

          <div class="variant-add">
            <p class="hint">{{ 'products.addVariantHint' | t }}</p>
            <div class="ct-form-grid variant-add-grid">
              <div class="ct-field">
                <label for="newVariantValue">{{ 'products.optionValue' | t }}</label>
                <input
                  id="newVariantValue"
                  class="ct-input"
                  [ngModel]="newVariantValue()"
                  (ngModelChange)="onNewVariantValueChange($event)"
                  [ngModelOptions]="{ standalone: true }"
                  [placeholder]="'products.optionValuePlaceholder' | t"
                />
              </div>
              <div class="ct-field">
                <label for="newVariantSku">SKU</label>
                <input
                  id="newVariantSku"
                  class="ct-input"
                  [ngModel]="newVariantSku()"
                  (ngModelChange)="newVariantSku.set($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>
              <div class="ct-field">
                <label for="newVariantPrice">{{ 'products.price' | t }}</label>
                <input
                  id="newVariantPrice"
                  class="ct-input"
                  type="number"
                  step="0.01"
                  [ngModel]="newVariantPrice()"
                  (ngModelChange)="newVariantPrice.set($event === '' || $event === null ? null : +$event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>
              <div class="ct-field">
                <label for="newVariantCompareAt">{{ 'products.compareAtPrice' | t }}</label>
                <input
                  id="newVariantCompareAt"
                  class="ct-input"
                  type="number"
                  step="0.01"
                  [ngModel]="newVariantCompareAt()"
                  (ngModelChange)="newVariantCompareAt.set($event === '' || $event === null ? null : +$event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>
              <div class="ct-field">
                <label for="newVariantActive">{{ 'common.active' | t }}</label>
                <input
                  id="newVariantActive"
                  type="checkbox"
                  [ngModel]="newVariantActive()"
                  (ngModelChange)="newVariantActive.set($event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>
              <div class="ct-field">
                <label>&nbsp;</label>
                <button class="ct-btn ct-btn-ghost" type="button" (click)="addVariant()">
                  {{ 'products.addVariant' | t }}
                </button>
              </div>
            </div>
          </div>

          <div class="ct-table-wrap">
            <table class="ct-table">
              <thead>
                <tr>
                  <th>{{ 'products.variant' | t }}</th>
                  <th>SKU</th>
                  <th>{{ 'products.price' | t }}</th>
                  <th>{{ 'products.compareAtPrice' | t }}</th>
                  <th>{{ 'common.active' | t }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                @for (variant of variantDrafts(); track variant.id) {
                  <tr>
                    <td>
                      @if (variant.optionValueId) {
                        <input
                          class="ct-input"
                          [ngModel]="variantOptionLabel(variant)"
                          (ngModelChange)="updateVariantValueLabel(variant.id, $event)"
                          [ngModelOptions]="{ standalone: true }"
                        />
                      } @else {
                        {{ 'products.defaultVariant' | t }}
                      }
                    </td>
                    <td>
                      <input
                        class="ct-input"
                        [ngModel]="variant.sku"
                        (ngModelChange)="updateVariantField(variant.id, 'sku', $event)"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td>
                      <input
                        class="ct-input"
                        type="number"
                        step="0.01"
                        [ngModel]="variant.price"
                        (ngModelChange)="updateVariantField(variant.id, 'price', $event)"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td>
                      <input
                        class="ct-input"
                        type="number"
                        step="0.01"
                        [ngModel]="variant.compareAtPrice"
                        (ngModelChange)="updateVariantField(variant.id, 'compareAtPrice', $event)"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        [ngModel]="variant.isActive"
                        (ngModelChange)="updateVariantField(variant.id, 'isActive', $event)"
                        [ngModelOptions]="{ standalone: true }"
                      />
                    </td>
                    <td>
                      @if (variant.optionValueId || variantDrafts().length > 1) {
                        <button
                          class="ct-btn ct-btn-danger ct-btn-sm"
                          type="button"
                          (click)="removeVariant(variant.id)"
                        >
                          {{ 'common.delete' | t }}
                        </button>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="attrs">
          <h3>{{ 'products.attributes' | t }}</h3>
          <p class="hint">{{ 'products.attributesHint' | t }}</p>
          @if (attributeFields().length === 0) {
            <p class="empty">{{ 'products.noAttributes' | t }}</p>
          } @else {
            <div class="ct-form-grid">
              @for (field of attributeFields(); track field.filterId) {
                <div class="ct-field">
                  <label [attr.for]="'attr-' + field.filterId">{{ field.name }}</label>
                  @if (field.valueType === 'Boolean') {
                    <select
                      class="ct-select"
                      [id]="'attr-' + field.filterId"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    >
                      <option value="">—</option>
                      <option value="true">{{ 'common.yes' | t }}</option>
                      <option value="false">{{ 'common.no' | t }}</option>
                    </select>
                  } @else if (field.valueType === 'Options') {
                    <select
                      class="ct-select"
                      [id]="'attr-' + field.filterId"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    >
                      <option value="">—</option>
                      @for (opt of field.options; track opt.value) {
                        <option [value]="opt.value">{{ opt.display }}</option>
                      }
                    </select>
                  } @else {
                    <input
                      class="ct-input"
                      [id]="'attr-' + field.filterId"
                      [type]="field.valueType === 'Number' ? 'number' : 'text'"
                      [step]="field.valueType === 'Number' ? 'any' : null"
                      [ngModel]="field.value"
                      [ngModelOptions]="{ standalone: true }"
                      (ngModelChange)="setAttributeValue(field.filterId, $event)"
                    />
                  }
                </div>
              }
            </div>
          }
        </div>

        <div class="attrs">
          <div class="section-head">
            <h3>{{ 'products.specifications' | t }}</h3>
            <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="addSpecRow()">
              {{ 'products.addSpec' | t }}
            </button>
          </div>
          <p class="hint">{{ 'products.specificationsHint' | t }}</p>
          <datalist id="spec-tags">
            @for (tag of categoryTags(); track tag.id) {
              <option [value]="tag.name"></option>
            }
          </datalist>
          @if (specDrafts().length === 0) {
            <p class="empty">{{ 'products.noSpecs' | t }}</p>
          } @else {
            <div class="two-col-list">
              @for (row of specDrafts(); track $index; let i = $index) {
                <div class="spec-row">
                  <input
                    class="ct-input"
                    list="spec-tags"
                    [placeholder]="'products.specTag' | t"
                    [ngModel]="row.name"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="setSpecTag(i, $event)"
                  />
                  <input
                    class="ct-input"
                    [placeholder]="'products.specValue' | t"
                    [ngModel]="row.value"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="setSpecValue(i, $event)"
                  />
                  <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="removeSpecRow(i)">
                    {{ 'common.delete' | t }}
                  </button>
                </div>
              }
            </div>
          }
        </div>

        <div class="attrs">
          <h3>Related Products</h3>
          <p class="hint">Search and add related products that will appear on this product's page.</p>
          <div class="related-search-wrap">
            <input
              class="ct-input"
              placeholder="Search by name or SKU…"
              [ngModel]="relatedSearch()"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="relatedSearch.set($event)"
            />
            @if (relatedSearchResults().length > 0) {
              <div class="related-dropdown">
                @for (result of relatedSearchResults(); track result.id) {
                  <button
                    class="related-option"
                    type="button"
                    (click)="addRelatedProduct(result)"
                  >
                    {{ result.name }} <span class="sku-hint">({{ result.sku }})</span>
                  </button>
                }
              </div>
            }
          </div>
          @if (relatedProducts().length === 0) {
            <p class="empty">No related products added.</p>
          } @else {
            <div class="two-col-list">
              @for (rp of relatedProducts(); track rp.id; let i = $index) {
                <div class="spec-row">
                  <span>{{ rp.name }} <span class="sku-hint">({{ rp.sku }})</span></span>
                  <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="removeRelatedProduct(rp.id)">
                    {{ 'common.delete' | t }}
                  </button>
                </div>
              }
            </div>
          }
        </div>

        @if (editingId()) {
          <div class="attrs">
            <h3>{{ 'products.images' | t }}</h3>
            <p class="hint">{{ 'products.imagesHint' | t }}</p>
            <div class="file-picker">
              <input
                #imageInput
                class="file-input"
                type="file"
                accept="image/jpeg,image/png,image/webp,image/gif"
                multiple
                [disabled]="mediaBusy()"
                (change)="onImagesSelected($event)"
              />
              <button
                class="ct-btn ct-btn-ghost ct-btn-sm"
                type="button"
                [disabled]="mediaBusy()"
                (click)="imageInput.click()"
              >
                <span class="material-symbols-outlined">image</span>
                {{ 'products.chooseImages' | t }}
              </button>
            </div>
            <div class="thumbs">
              @for (image of images(); track image.id) {
                <div class="thumb" [class.primary]="image.isPrimary">
                  <img [src]="image.url" alt="" appImgFallback />
                  <div class="thumb-actions">
                    @if (!image.isPrimary) {
                      <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="setPrimary(image)">
                        {{ 'products.setPrimary' | t }}
                      </button>
                    } @else {
                      <span class="primary-label">{{ 'products.primary' | t }}</span>
                    }
                    <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="removeImage(image)">
                      {{ 'common.delete' | t }}
                    </button>
                  </div>
                </div>
              } @empty {
                <p class="empty">{{ 'products.noImages' | t }}</p>
              }
            </div>
          </div>

          <div class="attrs">
            <h3>{{ 'products.documents' | t }}</h3>
            <p class="hint">{{ 'products.documentsHint' | t }}</p>
            <div class="doc-upload">
              <div class="file-picker">
                <input
                  #docInput
                  class="file-input"
                  type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,application/pdf"
                  [disabled]="mediaBusy()"
                  (change)="onDocumentSelected($event)"
                />
                <button
                  class="ct-btn ct-btn-ghost ct-btn-sm"
                  type="button"
                  [disabled]="mediaBusy()"
                  (click)="docInput.click()"
                >
                  <span class="material-symbols-outlined">upload_file</span>
                  {{ 'products.chooseFile' | t }}
                </button>
              </div>
              <input
                class="ct-input"
                [placeholder]="'products.documentTitle' | t"
                [ngModel]="docTitle()"
                [ngModelOptions]="{ standalone: true }"
                (ngModelChange)="docTitle.set($event)"
              />
              <button
                class="ct-btn ct-btn-primary ct-btn-sm"
                type="button"
                [disabled]="mediaBusy() || !pendingDocument()"
                (click)="uploadPendingDocument()"
              >
                {{ 'products.uploadDocument' | t }}
              </button>
              @if (pendingDocument()) {
                <button class="ct-btn ct-btn-ghost ct-btn-sm" type="button" (click)="clearPendingDocument()">
                  {{ 'common.cancel' | t }}
                </button>
              }
            </div>
            @if (pendingDocument(); as pending) {
              <p class="hint">{{ 'products.selectedFile' | t }}: {{ pending.name }}</p>
            }
            @if (documents().length === 0) {
              <p class="empty">{{ 'products.noDocuments' | t }}</p>
            } @else {
              <div class="two-col-list docs">
                @for (doc of documents(); track doc.id) {
                  <div class="doc-item">
                    <a [href]="doc.url" target="_blank" rel="noopener">{{ doc.title }}</a>
                    <button class="ct-btn ct-btn-danger ct-btn-sm" type="button" (click)="removeDocument(doc)">
                      {{ 'common.delete' | t }}
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          <p class="hint save-first">{{ 'products.saveBeforeMedia' | t }}</p>
        }

        </div>
        <div class="ct-dialog-actions">
          <button class="ct-btn ct-btn-ghost" type="button" (click)="closeDialog()">
            {{ 'common.cancel' | t }}
          </button>
          <button class="ct-btn ct-btn-primary" type="submit">{{ 'common.save' | t }}</button>
        </div>
      </form>
    </div>
  </div>
}
